/* L&G Data Classification: CONFIDENTIAL */
export const constants = {

  serviceEndPoints: {
    contentData: './assets/json/contentData.json',
    dcjConfigurationData: './assets/json/dcj-configuration.json'
  }
};
